
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre/pricing-ab-testing/pricing-ab-testing-for-elementor",
      function () {
        return require("private-next-pages/help-centre/pricing-ab-testing/pricing-ab-testing-for-elementor.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre/pricing-ab-testing/pricing-ab-testing-for-elementor"])
      });
    }
  